import type { GeoPoint } from '../../application/tracking/geo'

// Repris (adapt) de reca-app-v3 `src/features/routes/infrastructure/mapbox/streetTrace.ts` : un seul tronçon, de la
// position de la tablette à la résidence suggérée. Trajet indicatif par les rues (Mapbox Directions, « driving ») :
// l'opérateur reste libre de son chemin.

export interface StreetPath {
  path: GeoPoint[]
  distanceMeters: number
  durationSeconds: number
}

interface DirectionsBody {
  code?: string
  routes?: { geometry?: { coordinates?: [number, number][] }; distance?: number; duration?: number }[]
}

/** `null` si Mapbox ne trouve pas de trajet ou ne répond pas : jamais de trait droit à la place. */
export async function fetchStreetPath(
  from: GeoPoint,
  to: GeoPoint,
  token: string,
  signal: AbortSignal,
): Promise<StreetPath | null> {
  const coordinates = [from, to].map((point) => `${String(point.lng)},${String(point.lat)}`).join(';')
  const url = new URL(`https://api.mapbox.com/directions/v5/mapbox/driving/${coordinates}`)
  url.searchParams.set('access_token', token)
  url.searchParams.set('geometries', 'geojson')
  url.searchParams.set('overview', 'full')
  // Un tracteur peut faire demi-tour sur place (même réglage que l'écran Routes, 12 oct. 2026).
  url.searchParams.set('continue_straight', 'false')
  try {
    const response = await fetch(url, { signal })
    if (!response.ok) return null
    const body = (await response.json()) as DirectionsBody
    const route = body.routes?.[0]
    const points = route?.geometry?.coordinates
    if (body.code !== 'Ok' || !points || points.length < 2) return null
    return {
      path: points.map(([lng, lat]) => ({ lat, lng })),
      distanceMeters: Math.round(route.distance ?? 0),
      durationSeconds: Math.round(route.duration ?? 0),
    }
  } catch {
    return null
  }
}
